import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    // Paper renders labels inside an absoluteFill wrapper in a fixed-height
    // box; keep the label simple to avoid clipping.
    container: {
      alignItems: 'center',
      alignSelf: 'stretch',
      justifyContent: 'center'
    },
    label: { color: theme.colors.primary, textAlign: 'center', flexShrink: 1 }
  });

type Props = {
  label: string;
  testID?: string;
};

export const BottomTabbarLabel: FC<Props> = ({ label, testID }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View testID={testID} style={styles.container}>
      <Text
        maxFontSizeMultiplier={1.5}
        variant="labelMedium"
        numberOfLines={1}
        ellipsizeMode="tail"
        style={styles.label}
      >
        {label}
      </Text>
    </View>
  );
};
